import React from 'react';
import PropTypes from 'prop-types';

const PasswordRulesList = ({ rules, isPasswordEmpty }) => {
  const getColor = (valid) => {
    if (isPasswordEmpty) return '#718096';
    return valid ? '#38A169' : '#E53E3E';
  };

  return (
    <ul style={{ listStyle: 'none', paddingLeft: 0, marginTop: '1rem' }}>
      {rules.map((rule, idx) => (
        <li
          key={idx}
          style={{
            color: getColor(rule.valid),
            display: 'flex',
            alignItems: 'center',
            gap: '0.5rem',
            fontSize: '0.75rem',
            lineHeight: '1rem',
          }}
        >
          {rule.valid ? (
            <i className="bx bx-check" style={{ fontSize: '1.125rem' }} />
          ) : (
            <i className="bx bx-x" style={{ fontSize: '1.125rem' }} />
          )}
          {rule.label}
        </li>
      ))}
    </ul>
  );
};

PasswordRulesList.propTypes = {
  rules: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      valid: PropTypes.bool.isRequired,
    }),
  ).isRequired,
  isPasswordEmpty: PropTypes.bool,
};

export default PasswordRulesList;
